import gsap from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import ScrollTrigger from "gsap/ScrollTrigger";
import DeviceDetector from "../DeviceDetector";

gsap.registerPlugin(ScrollSmoother, ScrollTrigger);
export default class PageScrollSmoother {
  constructor() {
    this.deviceDetector = new DeviceDetector();
    this.isMobile = this.deviceDetector.isMobile();

    // const ele = document.getElementById("sticky-header");
    if (this.isMobile === false) {
      // ele.append(`not mobile device`);
      this.start();
    }
  }

  start() {
    this.scroll = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 2,
      smoothTouch: 0.1,
      effects: true,
    });
  }

  scrollTo(element) {
    if (this.isMobile === false) {
      this.scroll.scrollTo(element);
    }
  }
}
